import { docodeHexResponse } from '../../../_common/common.utils';
import SubGroupAccountActionTypes from './subGroupAccount.types';

const INITIAL_STATE = {
	// ADD SUB GROUP ACCOUNT DETAILS
	addSubGroupAccountDetailsResponse: null,
	// UPDATE SUB GROUP ACCOUNT DETAILS
	updateSubGroupAccountDetailsResponse: null,
	// GET SUB GROUP ACCOUNT LIST
	getSubGroupAccountListResponse: null,
	getSubGroupAccountListArr: [],
	// FETCH SUB GROUP ACCOUNT DETAILS
	fetchSubGroupAccountDetailsResponse: null,
	fetchSubGroupAccountDetailsArr: [],
	// DELETE SUB GROUP ACCOUNT DETAILS
	deleteSubGroupAccountDetailsResponse: null,
};

const subGroupAccountReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** ADD SUB GROUP ACCOUNT DETAILS START *********************** */
		case SubGroupAccountActionTypes.ADD_SUB_GROUP_ACCOUNT_DETAILS_SUCCESS:
			return { ...state, addSubGroupAccountDetailsResponse: action.payload };

		case SubGroupAccountActionTypes.ADD_SUB_GROUP_ACCOUNT_DETAILS_FAILURE:
			return { ...state, addSubGroupAccountDetailsResponse: action.payload };

		case SubGroupAccountActionTypes.ADD_SUB_GROUP_ACCOUNT_DETAILS_RESPONSE_CHANGED:
			return { ...state, addSubGroupAccountDetailsResponse: null };
		/** ***************** ADD SUB GROUP ACCOUNT DETAILS END *********************** */

		/** ***************** UPDATE SUB GROUP ACCOUNT DETAILS START *********************** */
		case SubGroupAccountActionTypes.UPDATE_SUB_GROUP_ACCOUNT_DETAILS_SUCCESS:
			return { ...state, updateSubGroupAccountDetailsResponse: action.payload };

		case SubGroupAccountActionTypes.UPDATE_SUB_GROUP_ACCOUNT_DETAILS_FAILURE:
			return { ...state, updateSubGroupAccountDetailsResponse: action.payload };

		case SubGroupAccountActionTypes.UPDATE_SUB_GROUP_ACCOUNT_DETAILS_RESPONSE_CHANGED:
			return { ...state, updateSubGroupAccountDetailsResponse: null };
		/** ***************** UPDATE SUB GROUP ACCOUNT DETAILS END *********************** */

		/** ***************** GET SUB GROUP ACCOUNT LIST START *********************** */
		case SubGroupAccountActionTypes.GET_SUB_GROUP_ACCOUNT_LIST_SUCCESS:
			return {
				...state,
				getSubGroupAccountListResponse: action.payload,
				getSubGroupAccountListArr: docodeHexResponse(
					action.payload,
					'FetchAllSubGroupAccountKey',
				),
			};

		case SubGroupAccountActionTypes.GET_SUB_GROUP_ACCOUNT_LIST_FAILURE:
			return { ...state, getSubGroupAccountListResponse: action.payload };

		case SubGroupAccountActionTypes.GET_SUB_GROUP_ACCOUNT_LIST_RESPONSE_CHANGED:
			return { ...state, getAccountListResponse: null };
		/** ***************** GET SUB GROUP ACCOUNT LIST END *********************** */

		/** ***************** FETCH SUB GROUP ACCOUNT DETAILS START *********************** */
		case SubGroupAccountActionTypes.FETCH_SUB_GROUP_ACCOUNT_DETAILS_SUCCESS:
			return {
				...state,
				fetchSubGroupAccountDetailsResponse: action.payload,
				fetchSubGroupAccountDetailsArr: docodeHexResponse(
					action.payload,
					'FetchSubGroupAccountKey',
				),
			};

		case SubGroupAccountActionTypes.FETCH_SUB_GROUP_ACCOUNT_DETAILS_FAILURE:
			return { ...state, fetchSubGroupAccountDetailsResponse: action.payload };

		case SubGroupAccountActionTypes.FETCH_SUB_GROUP_ACCOUNT_DETAILS_RESPONSE_CHANGED:
			return { ...state, fetchSubGroupAccountDetailsResponse: null };
		/** ***************** FETCH SUB GROUP ACCOUNT DETAILS END *********************** */

		/** ***************** DELETE SUB GROUP ACCOUNT DETAILS START *********************** */
		case SubGroupAccountActionTypes.DELETE_SUB_GROUP_ACCOUNT_DETAILS_SUCCESS:
			return { ...state, deleteSubGroupAccountDetailsResponse: action.payload };

		case SubGroupAccountActionTypes.DELETE_SUB_GROUP_ACCOUNT_DETAILS_FAILURE:
			return { ...state, deleteSubGroupAccountDetailsResponse: action.payload };

		case SubGroupAccountActionTypes.DELETE_SUB_GROUP_ACCOUNT_DETAILS_RESPONSE_CHANGED:
			return { ...state, deleteSubGroupAccountDetailsResponse: null };
		/** ***************** DELETE SUB GROUP ACCOUNT DETAILS END *********************** */

		default:
			return state;
	}
};
export default subGroupAccountReducer;
